/* Publish by EComposer at 2026-10-28 08:28:08*/
;try{
 (function () {
  // robots
  var m = document.createElement('meta');
  m.setAttribute('name', 'robots');
  m.setAttribute('content', 'noindex, nofollow');
  document.head.appendChild(m);

  // optional: explizit für Google
  var g = document.createElement('meta');
  g.setAttribute('name', 'googlebot');
  g.setAttribute('content', 'noindex, nofollow');
  document.head.appendChild(g);

  // optional: canonical auf sich selbst, falls nötig
  if (!document.querySelector('link[rel="canonical"]')) {
    var c = document.createElement('link');
    c.setAttribute('rel', 'canonical');
    c.setAttribute('href', location.href.split('#')[0]);
    document.head.appendChild(c);
  }
})();

} catch(error){console.error(error);}